import { createPortal } from "react-dom";
import { resolveAppMediaUrl } from "../../utils/resolveAppMediaUrl";
import { SPACE_TAB_BAR_LAYOUT } from "./SpaceTabBarConfig";
import type { SpaceTabItem } from "../SpaceType";
import "./SpaceTabBarStyle.css";

type Props = {
  tabs: SpaceTabItem[];
  activeKey: string;
  onChange: (key: string) => void;
};

export function SpaceTabBar(props: Props) {
  const { tabs, activeKey, onChange } = props;
  const debug = SPACE_TAB_BAR_LAYOUT.showRegionDebugColors;
  const bar = (
    <footer
      className={debug ? "space-tab-bar-shell space-tab-bar-shell--debug-regions" : "space-tab-bar-shell"}
    >
      <nav className="space-tab-bar" aria-label="空间导航" data-tab-region="content">
        {tabs.map((tab) => {
          const active = tab.key === activeKey;
          const iconSrc = resolveAppMediaUrl(active ? tab.activeIconUrl : tab.deactiveIconUrl);
          return (
            <button
              key={tab.key}
              type="button"
              className={`space-tab-bar-item${active ? " space-tab-bar-item--active" : ""}`}
              onClick={() => onChange(tab.key)}
              aria-current={active ? "page" : undefined}
            >
              {iconSrc ? (
                <img
                  className="space-tab-bar-icon"
                  src={iconSrc}
                  alt=""
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              ) : (
                <span className="space-tab-bar-icon" aria-hidden />
              )}
              <span className="space-tab-bar-label">{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </footer>
  );

  return createPortal(bar, document.body);
}
